function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "51B0229F-57B9-4C43-9563-1293852C8D54");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M12,7.0052 L12,16.0002 L2,16.0002 L2,2.0002 L7.99,2.0002 L7.99,4.4892 C7.99,5.3182 8.661,5.9892 9.49,5.9892 L13.99,5.9892 L13.99,5.4682 C13.99,5.1712 13.858,4.8902 13.631,4.7002 L8.557,0.4642 C8.197,0.1642 7.744,0.0002 7.275,0.0002 L2,0.0002 C0.895,0.0002 0,0.8952 0,2.0002 L0,16.0002 C0,17.1042 0.895,18.0002 2,18.0002 L12,18.0002 C13.105,18.0002 14,17.1042 14,16.0002 L14,7.0052 L12,7.0052 Z M5.9906311,12 C6.50827165,12 6.93490293,12.3827202 6.99320924,12.8826674 L7,13 C7,13.5522847 6.55664682,14 5.9906311,14 L4.0093689,14 C3.45190985,14 3,13.5561352 3,13 C3,12.4477153 3.44335318,12 4.0093689,12 L5.9906311,12 Z M10.0029699,9 C10.5142826,9 10.9356987,9.38272018 10.9932922,9.88266744 L11,10 C11,10.5522847 10.5469637,11 10.0029699,11 L3.99703014,11 C3.4463856,11 3,10.5561352 3,10 C3,9.44771525 3.45303631,9 3.99703014,9 L10.0029699,9 Z",
  id: "path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Vendor",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vendor-Registration-/-Section-2-/-Add-New-&-Edit---View",
  transform: "translate(-991.000000, -575.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(956.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(25.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(0.000000, 62.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10",
  transform: "translate(0.000000, 441.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(0.000000, 32.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(5.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "standard/content/file",
  transform: "translate(5.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Fill-1",
  fill: "#42526E",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u21B3-\\uD83C\\uDFA8Color",
  mask: "url(#mask-2)",
  fill: "#97A0AF"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-5.000000, -3.000000)",
  id: "N80"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0 24 24 24 24 0 0 0"
}))))))))))));

var SvgFile = function SvgFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file.a47c091c.svg";
export { ForwardRef as ReactComponent };